import { TableCell, TableRow } from "@mui/material";
import { useContext } from "react";
import { ClientType } from "src/services/admin/queries/NetTypes";

import Context from "../../context";
import cols from "./Cols";

export default function RowClient(client: ClientType) {
	const { actions } = useContext(Context);
	return (
		<TableRow hover sx={{ cursor: "pointer" }} onClick={() => actions.showEditDialog(client)}>
			{cols.map(({ Cell, align }, index) => (
				<TableCell align={align} key={index}>
					<Cell {...client} />
				</TableCell>
			))}
		</TableRow>
	);
}
